import React from 'react';
import { ButtonProps } from 'antd';
import * as S from './styles';

interface ButtonDefaultProps extends ButtonProps {
	children: React.ReactNode;
}

export default function ButtonDefault({ children, ...props }: Readonly<ButtonDefaultProps>): JSX.Element {
	return <S.CustomButton {...props}>{children}</S.CustomButton>;
}
